/**
 * Created by Administrador on 16/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('clientsCtrl', clientsCtrl)
        .controller('newClientCtrl', newClientCtrl)
        .controller('editClientCtrl', editClientCtrl)
        /*.controller('deleteUserController', deleteUserController)*/
        .controller('modalApplyGrantTypeCtrl', modalApplyGrantTypeCtrl);

    clientsCtrl.$inject = ['clients'];
    newClientCtrl.$inject = ['$uibModal','linkService', 'clientService','userService'];
    editClientCtrl.$inject = ['$uibModal','linkService','clientService','userService','client'];
    /*deleteUserController.$inject = ['userId', 'user', 'userService', '$uibModalInstance'];*/
    modalApplyGrantTypeCtrl.$inject = ['$uibModalInstance', 'linkService','stringGrantTypes'];

    function clientsCtrl(clients){
        var vm = this;
        vm.pages = [];
        vm.clients = (clients) ? clients.data.content : [];
        vm.pages = clients? clients.data: {};
    }

    function newClientCtrl($uibModal, linkService, clientService, userService){
        var vm = this;
        vm.selectCheckBox = {};
        vm.client = {
            ui: false
        };

        vm.saveClient = function(isValid, client){
            if(isValid){
                var scope = (vm.selectCheckBox[1]?('read'+(vm.selectCheckBox[2]?',':'')):'')+
                    (vm.selectCheckBox[2]?'write':'');
                client.scope=scope;
                client.webServerRedirectUrl = '';
                client.additionalInformation ='{}';
                client.authorities = 'ROLE_CLIENT';
                client.autoApprove = '';
                if(client.ui){
                    clientService.saveOauthClient(client);
                }else{
                    var user = {
                        "name": client.client,
                        "lastName": client.client,
                        "login": client.email,
                        "email": client.email
                    }
                    userService.saveUserCredential(user)
                        .then(function(response){
                            if(response){
                                clientService.saveOauthClient(client)
                                    .then(function(response){
                                            if(!response){
                                                userService.deleteUserCredential(client.client,client.email);
                                            }
                                        }
                                    )
                            }
                        }
                    )
                }
            }
        }

        vm.addApplyGrantType = function(grantTypes){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/client/modalApplyGrantType.html',
                controller: 'modalApplyGrantTypeCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    stringGrantTypes: [function() {
                        return grantTypes
                    }]
                }
            }).result.then(function(response) {
                vm.client.authorizedGrantTypes = response.grantType;
            }, function() {
                //$state.go('^');
            });
        }
    }

    function editClientCtrl($uibModal, linkService, clientService, userService,client){
        var vm = this;
        vm.linkService = linkService;
        vm.client = client.data?client.data:{};
        vm.selectCheckBox = {};
        vm.edit = true;
        vm.originUi = vm.client.ui;
        vm.selectCheckBox[1] = (vm.client.scope.indexOf("read")>-1)?true:false;
        vm.selectCheckBox[2] = (vm.client.scope.indexOf("write")>-1)?true:false;
        if(!vm.originUi){
            userService.getUserCredential(vm.client.client)
                .then(function(response){
                    vm.client.email =  response != undefined && response.data?response.data.email:"";
                    vm.old = angular.copy(vm.client);
                });
        }else{
            vm.old = angular.copy(vm.client);
        }
        vm.buttonSave = true;
        vm.oldBox = angular.copy(vm.selectCheckBox);

        vm.saveClient = function(isValid, client){
            if (isValid) {
                var scope = (vm.selectCheckBox[1]?('read'+(vm.selectCheckBox[2]?',':'')):'')+
                    (vm.selectCheckBox[2]?'write':'');
                client.scope=scope;
                if(client.ui){
                    if(!vm.originUi){
                        userService.deleteUserCredential(client.client,client.email);
                    }
                    clientService.updateOauthClient(client);
                }else{
                    var user = {
                        "name": client.client,
                        "lastName": client.client,
                        "email": client.email
                    }

                    if(vm.originUi){
                        user.login = client.email;
                        userService.saveUserCredential(user)
                            .then(function(response){
                                    if(response){
                                        clientService.updateOauthClient(client)
                                            .then(function(response){
                                                    if(!response){
                                                        userService.deleteUserCredential(client.client,client.email);
                                                    }
                                                }
                                            )
                                    }
                                }
                            )
                    }else{
                        userService.updateUserCredential(user)
                            .then(function(response){
                                    if(response){
                                        clientService.updateOauthClient(client);
                                    }
                                }
                            )
                    }
                }
            }
        }

        vm.addApplyGrantType = function(grantTypes){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/client/modalApplyGrantType.html',
                controller: 'modalApplyGrantTypeCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    stringGrantTypes: [function() {
                        return grantTypes
                    }]
                }
            }).result.then(function(response) {
                vm.client.authorizedGrantTypes = response.grantType;
                vm.change();
            }, function() {
                //$state.go('^');
            });
        }

        vm.change = function(){
            if(vm.client.nameUi.toUpperCase() == vm.old.nameUi.toUpperCase() &&
                vm.client.client.toUpperCase() == vm.old.client.toUpperCase() &&
                vm.client.name.toUpperCase() == vm.old.name.toUpperCase() &&
                vm.client.clientSecret.toUpperCase() == vm.old.clientSecret.toUpperCase() &&
                vm.selectCheckBox[1] == vm.oldBox[1] && vm.selectCheckBox[2] == vm.oldBox[2] &&
                vm.client.authorizedGrantTypes.toUpperCase() == vm.old.authorizedGrantTypes.toUpperCase() &&
                vm.client.accessTokenValidity == vm.old.accessTokenValidity &&
                vm.client.refreshTokenValidity == vm.old.refreshTokenValidity &&
                vm.client.ui == vm.old.ui){
                if(vm.client.ui){
                    vm.buttonSave = true;
                }else {
                    if(vm.client.email == vm.old.email){
                        vm.buttonSave = true;
                    }else{
                        vm.buttonSave = false;
                    }
                }
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteUserController(userId, user, userService, $uibModalInstance){
        var vm = this;
        vm.name = user.data.name + " " + user.data.lastName;

        vm.deleteUser = function(){
            userService.deleteUser(userId)
                .then(function(){
                    $uibModalInstance.close(true);
                });
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function modalApplyGrantTypeCtrl($uibModalInstance, linkService, stringGrantTypes){
        var vm = this;
        vm.linkService = linkService;
        vm.granType = {}
        vm.grantTypes = [
            {
                'id': 1,
                'name': "Authorization Code",
                'code': "authorization_code"
            },
            {
                'id': 2,
                'name': "Client Credentials",
                'code': "client_credentials"
            },
            {
                'id': 3,
                'name': "Implicit",
                'code': "implicit"
            },
            {
                'id': 4,
                'name': "Password",
                'code': "password"
            },
            {
                'id': 5,
                'name': "Refresh Token",
                'code': "refresh_token"
            }
        ];
        vm.grantTypesCheckBox = getSelectCheckBox(vm.grantTypes, stringGrantTypes);

        vm.addGrantType = function(isValid, grantType){
            if(isValid){
                var resModal;

                var dataRes = '';
                angular.forEach(vm.grantTypes, function(grantType){
                    var id = grantType.id;
                    if(vm.grantTypesCheckBox[id] == true){
                        dataRes = dataRes+(dataRes.length==0?'':',')+grantType.code;
                    }
                });

                resModal = dataRes;

                $uibModalInstance.close({grantType: resModal});
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getSelectCheckBox(granTypes,stringGrantType){
            var selectCheckBox = {};
            angular.forEach(granTypes, function(grantType){
                if(stringGrantType == undefined){
                    selectCheckBox[grantType.id] = false;
                }else{
                    if(stringGrantType.indexOf(grantType.code)>-1){
                        selectCheckBox[grantType.id] = true;
                    }
                }
            });
            return selectCheckBox;
        }
    }
})();
